import { render, staticRenderFns } from "./MenuItemRecursive.vue?vue&type=template&id=200f0b3e&scoped=true"
import script from "./MenuItemRecursive.vue?vue&type=script&lang=js"
export * from "./MenuItemRecursive.vue?vue&type=script&lang=js"
import style0 from "./MenuItemRecursive.vue?vue&type=style&index=0&id=200f0b3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200f0b3e",
  null
  
)

export default component.exports